import { jsx as _jsx } from "react/jsx-runtime";
import { BaseTableLoadingRoot, BaseTableLoadingTitle, BaseTableLoadingWrapper } from './BaseTableLoading.styled';
// Component.
// -----------------------------------------------------------------------------
export const BaseTableLoading = ({ label, span }) => (_jsx(BaseTableLoadingRoot, { children: _jsx("td", { colSpan: span, children: _jsx(BaseTableLoadingWrapper, { children: _jsx(BaseTableLoadingTitle, { children: label }) }) }) }));
//# sourceMappingURL=BaseTableLoading.js.map